import { appType } from "@/shared/lib/appType";

// 마지막으로 등록 dispatch 에 성공한 JWT. 동일 토큰 중복 호출을 막고, refresh 로 토큰이 바뀌면 재등록한다.
// ⚠️ 마킹은 "호출 가능한 bridge handler 에 실제로 dispatch 한" 경우에만 — 미주입/Web/예외면 마킹하지 않아 다음 트리거에서 재시도된다.
let lastRegisteredJwt: string | null = null;

/**
 * 네이티브 디바이스 등록을 트리거한다 (BRIDGE_PROTOCOL §1.6, DEVICE_REGISTRATION.md).
 *
 * FE 는 JWT access token 만 넘긴다 — 일회용 키 발급·AES-GCM 암호화·`POST /devices/me` 는 전부 native 책임.
 * best-effort 계약: 결과 콜백이 없고, 실패해도 사용자 흐름을 막지 않는다 (재시도는 native 가 처리, Crashlytics 기록).
 *
 * 호출 시점 (DEVICE_REGISTRATION §5.1): 앱 셸(홈) 진입 시 token 존재 / access token refresh 후.
 */
export const triggerDeviceRegistration = (jwt: string): void => {
  if (!jwt || jwt === lastRegisteredJwt) return;

  try {
    const platform = appType();

    if (platform === "iOS") {
      const handler = window.webkit?.messageHandlers?.registerDeviceHandler;
      if (!handler) return; // bridge 미주입 (예: OAuth 도메인 진입 중) — 마킹하지 않아 다음 트리거에서 재시도
      handler.postMessage(jwt); // receiver = handler (postMessage 는 handler 의 메서드 — 안전)
      lastRegisteredJwt = jwt;
      return;
    }

    if (platform === "Android") {
      const bridge = window.maketrend;
      if (!bridge?.registerDevice) return; // 미주입이면 마킹하지 않음
      bridge.registerDevice(jwt); // 객체-메서드 호출로 receiver 보존 (메서드 분리 호출 금지)
      lastRegisteredJwt = jwt;
      return;
    }

    // Web: bridge 가 없으므로 no-op. 마킹하지 않는다.
  } catch {
    // best-effort — native 호출 실패가 JS 흐름을 깨면 안 된다 (마킹 전 단계라 다음 트리거에서 재시도 가능).
  }
};
